module.exports = __webpack_public_path__ + "img/baSys.4a19caa7.svg";